import { render, staticRenderFns } from "./WhitePaper.vue?vue&type=template&id=ebf31132&"
import script from "./WhitePaper.vue?vue&type=script&lang=js&"
export * from "./WhitePaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports